import {openModal} from "../html-elements/modal";
import {post} from "../functions";
import {toast} from "../html-elements/toast";
import {standardResponse} from "../messages";

//Open and close user menu
const menu = document.querySelector('aside .user');

document.querySelector('aside .user .card')?.addEventListener('click', (e) => {
    // e.stopPropagation();
    menu.classList.toggle('is-open');
});

document.addEventListener('click', (e) => {
    if (menu && !menu.contains(e.target)) {
        closeMenu();
    }
});

function closeMenu() {
    menu.classList.remove('is-open');
}

//User menu buttons
menu?.querySelectorAll('.user-menu .menu').forEach(menu => {
    menu.addEventListener('click', () => {
        const action = menu.dataset.action
        switch (action) {
            case 'user-menu-profile':
            case 'user-menu-password':
                openModal(action);
                break;
            case 'user-menu-saved-logins':
                window.location.href = 'saved-logins';
                break;
            case 'user-menu-logout':
                window.location.href = 'logout.php';
                break;
        }
    });
});

//Edit profile modal
const editProfileModal = document.querySelector('dialog[data-name="user-menu-profile"]');
const editProfileForm = document.getElementById('edit-profile-form');
const menuName = document.getElementById('user-menu-name');
const menuEmail = document.getElementById('user-menu-email');

editProfileForm?.addEventListener('submit', () => {
        if (editProfileForm.validateForm()) {
            post('api/user/edit-profile', editProfileForm).then(resp => {
                console.log(resp);
                if (resp.status === '200') {
                    menuName.textContent = resp.payload.name;
                    menuEmail.textContent = resp.payload.email;
                    editProfileForm.refreshDefaultValues();
                    editProfileModal.close();
                }
                standardResponse(resp.status, resp.payload.message||'');
            })
        } else {
            standardResponse('000');
        }
    }
)

//Change password modal
const changePasswordModal = document.querySelector('dialog[data-name="user-menu-password"]');
const changePasswordForm = document.getElementById('change-password-form');
const currentPassword = changePasswordForm?.querySelector('input[name="current_password"]');
const newPassword = changePasswordForm?.querySelector('input[name="new_password"]');
const confirmPassword = changePasswordForm?.querySelector('input[name="confirm_password"]');

changePasswordForm?.addEventListener('submit', () => {
        if (changePasswordForm.validateForm()) {
            if (currentPassword.value === newPassword.value) {
                toast('Az új jelszó nem egyezhet meg a jelenlegi jelszóval.');
                return;
            }

            if (newPassword.value !== confirmPassword.value) {
                toast('A két új jelszó nem egyezik meg.', 'warning');
                return;
            }

            post('api/user/change-password', changePasswordForm).then(resp => {
                console.log(resp);
                if (resp.status === '200') {
                    changePasswordModal.close();
                }
                standardResponse(resp.status, resp.payload.message||'');
            })
        } else {
            standardResponse('000');
        }
    }
)